import { Constants } from "@core/Utils/Constants";

export class Assets {

	Screen1920_normal_png = "Screen1920_normal.png"

	Background = new class {
		NoButtons = "Screen1920_normal_no_buttons.png"
	}

	static Panel = {
		Fullscreen_Button:
		{
			name: "fullscreen.png"
		},
		History_Button:
		{
			name: "history_small.png"
		},
		Play_Button: {
			name: "play_button.png"
		},
		Paint_Mode_Button: {
			On:
			{
				name: "paint_mode_selected.png"
			},
			Off:
			{
				name: "paint_mode_normal.png"
			},
		},
		Menu_Button: {
			name: "menu.png"
		},
		Speaker_On: {
			name: "Speaker_On_Icon.png"
		},
		Speaker_Off: {
			name: "Speaker_Off_Icon.png"
		},
		Help_Screen_Button: {
			name: "question_mark_icon.png"
		}
	}

	static chipAtlas: string = Constants.SPRITESHEET;

	static chips = [
		{
			name: "ChipX",
			normal: "chipX_new_5_N_V2.png",
			disabled: "chipX_new_5_D_V2.png",
			multiple: "chipX_multiple_5_N.png"
		},
		{
			name: "Chip1",
			normal: "chip1_N.png",
			disabled: "chip1_D.png"
		},
		{
			name: "Chip2",
			normal: "chip2_N.png",
			disabled: "chip2_D.png"
		},
		{
			name: "Chip3",
			normal: "chip3_N.png",
			disabled: "chip3_D.png"
		},
		{
			name: "Chip4",
			normal: "chip4_N.png",
			disabled: "chip4_D.png"
		},
		{
			name: "Chip5",
			normal: "chip5_N.png",
			disabled: "chip5_D.png"
		}
	]

	static betChips = [
		{
			name: "BetChips0_png",
			// BEFORE IT WAS normal: "chips0.png"
			// ONLY HAPPENS WHEN LIMITS BUG OUT
			// AND ASSIGN A VALUE TO A FIELD LOWER THAN 
			// THE VALUE OF LOWEST CHIP VALUE
			normal: "chip1_N.png"
		},
		{
			name: "BetChips1_png",
			normal: "chip1_N.png"
		},
		{
			name: "BetChips2_png",
			normal: "chip2_N.png"
		},
		{
			name: "BetChips3_png",
			normal: "chip3_N.png"
		},
		{
			name: "BetChips4_png",
			normal: "chip4_N.png"
		},
		{
			name: "BetChips5_png",
			normal: "chip5_N.png"
		}
	]

	static Board = {
		Buttons: {
			Neighbour_Bet: {
				Normal: "button_neighbour_bet.png",
				Hover: "button_neighbour_bet_hover.png",
				Disabled: "button_neighbour_bet_disabled.png",
			},
			Track_Switch: {
				Normal: "button_track.png",
				Hover: "button_track_hover.png",
				Disabled: "button_track_disabled.png",
			},
			Repeat_Bets: {
				Normal: "button_repeat_bets.png",
				Hover: "button_repeat_bets_hover.png",
				Disabled: "button_repeat_bets_disabled.png",
			},
			Undo_Bet: {
				Normal: "button_undo.png",
				Hover: "button_undo_hover.png",
				Disabled: "button_undo_disabled.png",
			},
			Zero_Game: {
				Normal: "button_zero_game.png",
				Hover: "button_zero_game_hover.png",
				Disabled: "button_zero_game_disabled.png",
			},
			Big_Series: {
				Normal: "button_big_series.png",
				Hover: "button_big_series_hover.png",
				Disabled: "button_big_series_disabled.png",
			},
			Orphans: {
				Normal: "button_orphans.png",
				Hover: "button_orphans_hover.png",
				Disabled: "button_orphans_disabled.png",
			},
			Small_Series: {
				Normal: "button_small_series.png",
				Hover: "button_small_series_hover.png",
				Disabled: "button_small_series_disabled.png",
			},
			Board_Button_Zero:
			{
				Single_Zero:
				{
					Normal: "board_button_0.png",
					Hover: "board_button_0_hover.png",
					Win: "board_button_0_win.png",
				},
				Double_Zero_0:
				{
					Normal: "board_button_00_0.png",
					Hover: "board_button_00_0_hover.png",
					Win: "board_button_00_0_win.png",
				},
				Double_Zero_00:
				{
					Normal: "board_button_00_00.png",
					Hover: "board_button_00_00_hover.png",
					Win: "board_button_00_00_win.png",
				},
			},
		}
	}

	static Track = {
		Buttons: {
			Board_Switch: {
				Normal: "button_board.png",
				Hover: "button_board_hover.png",
				Disabled: "button_board_disabled.png",
			},
			Track_Black: {
				Normal: "Track_Black_Button.png",
				Hover: "Track_Black_Button_Hover.png",
				Disabled: "Track_Black_Button_Disabled.png",
			},
			Track_Red: {
				Normal: "Track_Red_Button.png",
				Hover: "Track_Red_Button_Hover.png",
				Disabled: "Track_Red_Button_Disabled.png",
			},
			Wide_Bet: {
				Normal: "button_wide_bet.png",
				Hover: "button_wide_bet_hover.png",
				Disabled: "button_wide_bet_disabled.png",
			},
			Single_Zero:
			{
				Normal: "track_button_0.png",
				Hover: "track_button_0_hover.png",
				Win: "track_button_0_win.png",
			}
		}
	}

	static PresetPanel = {
		Buttons: {
			Preset_Switch: {
				Normal: "button_presets.png",
				Hover: "button_presets_hover.png",
				Disabled: "button_presets_disabled.png"
			},
			Preset_Button_1: {
				Normal: "Preset_Button_1.png",
				Hover: "Preset_Button_1_Hover.png",
				Disabled: "Preset_Button_1_Disabled.png"
			},
			Preset_Button_2: {
				Normal: "Preset_Button_2.png",
				Hover: "Preset_Button_2_Hover.png",
				Disabled: "Preset_Button_2_Disabled.png"
			},
			Preset_Button_3: {
				Normal: "Preset_Button_3.png",
				Hover: "Preset_Button_3_Hover.png",
				Disabled: "Preset_Button_3_Disabled.png"
			},
			Preset_Button_4: {
				Normal: "Preset_Button_4.png",
				Hover: "Preset_Button_4_Hover.png",
				Disabled: "Preset_Button_4_Disabled.png"
			},
			Preset_Button_5: {
				Normal: "Preset_Button_5.png",
				Hover: "Preset_Button_5_Hover.png",
				Disabled: "Preset_Button_5_Disabled.png"
			},
			Preset_Button_6: {
				Normal: "Preset_Button_6.png",
				Hover: "Preset_Button_6_Hover.png",
				Disabled: "Preset_Button_6_Disabled.png"
			},
			Preset_Button_7: {
				Normal: "Preset_Button_7.png",
				Hover: "Preset_Button_7_Hover.png",
				Disabled: "Preset_Button_7_Disabled.png"
			},
			Preset_Button_8: {
				Normal: "Preset_Button_8.png",
				Hover: "Preset_Button_8_Hover.png",
				Disabled: "Preset_Button_8_Disabled.png"
			},
			Preset_Hover_Button: "preset_buttons_hover.png"
		}
	}

	static WinNumberHistory = {
		SingleZeroTexture: "0_history_display.png",
		DoubleZeroTexture: "00_history_display.png",
	}

	settings = new class {
		Audio = "mute.png"
	}
}
